import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = (typeof localStorage !== 'undefined' && localStorage.getItem('language')) || 'en';
    const cloned = request.clone({ setHeaders: { 'Accept-Language': lang } });
    return next.handle(cloned);
  }
}
